export const Default = {
    0: '否',
    1: '是',
};

export const Symbols = {
    Equals: '=',
    GreatThan: '＞',
    NotLess: '≥',
    LessThan: '＜',
    NotGreat: '≤',
};

export const MedicineType = {
    Research_drugs: '药物',
    Technology: '技术类（如细胞技术）',
    Medical_instruments: '医疗器械',
    Vaccines: '疫苗',
    Diagnostic_reagent: '诊断试剂',
    Others: '其他',
};

export const RequestStatus = {
    Unconfirmed: '未确认',
    Tobe_PM_Confirmed: '待PM确认',
    PM_Reject_Confirmed: 'PM拒绝确认',
    Tobe_FIN_Confirmed: '待FIN确认',
    FIN_Reject_Confirmed: 'FIN拒绝确认',
    FIN_Confirmed: 'FIN已确认',
};

export const ContractNature = {
    FIRST_CONTRACT: '首次合同',
    SUPPLEMENT_CONTRACT: '补充合同',
    RENEW_CONTRACT: '续签合同',
    TERMINATION_CONTRACT: '终止合同',
    TERMINATION_LETTER: '终止函',
};


// WEBPACK FOOTER //
// ./src/components/contractManagement/contractRecord/constants.js